export const keyIsNativePlatform = Symbol('is-native-platform')
export const keyPlatform = Symbol('platform')
export const keyLoggedIn = Symbol('logged-in')
export const keyDevice = Symbol('device');
export const keyFunctions = Symbol('functions')
export const keyAuth = Symbol('auth')
export const keyToastManager = Symbol('toast-manager')
export const keyUserActionProcessor = Symbol('user-action-processor')
export const keyBrowseNavigator = Symbol('browse-navigator')